import axios from "axios";
import { getToken, clearAuthData } from "./authService";

// Create axios instance with default config
const apiClient = axios.create({
  baseURL: "https://api.howzitstar.com/api/v1",
  timeout: 10000,
});

// Request interceptor to add auth token to every request
apiClient.interceptors.request.use(
  (config) => {
    const token = getToken();
    if (token) {
      config.headers["X-Authorization"] = token;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle common errors
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Token expired or invalid
      clearAuthData();
      window.location.href = "/";
    }
    return Promise.reject(error);
  }
);

export default apiClient;
